import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({ name: 'home', owner: 'cella', scope: ['frontend'], description: 'Home page and landing UI components.' });
